import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Uploads a ledger Excel/PDF file for single or multiple entities.
 * POST api/Onboarding/upload-ledger
 * Form fields: EntityIdList (can be single or multiple), File
 *
 * @param {{ entityIds: string[], file: File }} params - entityIds array of entity IDs
 * @returns {{ success: boolean, data?: array, error?: string }}
 * Response format: [{ entityId, fileName, filePath, success, message }]
 */
export const uploadExcelAction = async ({ entityIds, file }) => {
  try {
    const formData = new FormData();

    // Append each entity ID separately (API expects multiple EntityIdList fields)
    if (Array.isArray(entityIds)) {
      entityIds.forEach((id) => {
        formData.append("EntityIdList", id);
      });
    } else {
      // Fallback for single entity ID
      formData.append("EntityIdList", entityIds || "");
    }

    formData.append("File", file);

    const response = await apiClient.post(ATP_API_URL.UPLOAD_EXCEL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.status === 200) {
      return { success: true, data: response.data };
    }
    return { success: false, error: "Upload failed" };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
